<template>
  <header class="mobile-header">
    <router-link to="/" class="logo">
      <img src="../assets/mh_small_bg_64.png" alt="Mediocre Hobbies">
    </router-link>

    <input class="side-menu" type="checkbox" id="side-menu" v-model="isMenuOpen" />
    <label class="hamb" for="side-menu"><span class="hamb-line"></span></label>

    <nav class="nav">
        <ul class="menu">
            <li><router-link to="/" exact-active-class="active" @click="closeMenu">Home</router-link></li>
            <li><router-link to="/videos" active-class="active" @click="closeMenu">Videos</router-link></li>
            <!-- <li><router-link to="/stream" active-class="active" @click="closeMenu">Stream</router-link></li> -->
            <li><router-link to="/merch" active-class="active" @click="closeMenu">Merch</router-link></li>
            <li><router-link to="/affiliates" active-class="active" @click="closeMenu">Affiliates</router-link></li>
            <!-- <li><router-link to="/campaigns" active-class="active" @click="closeMenu">Campaign</router-link></li> -->
        </ul>
    </nav>
  </header>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'MobileHeader',
  data() {
    return {
      isMenuOpen: false
    }
  },
  methods: {
    closeMenu() {
      this.isMenuOpen = false;
    }
  }
});
</script>
